export { camelCase, kebabCase, startCase, snakeCase, lowerCase, upperCase, lowerFirst, upperFirst, capitalize, } from 'lodash-es';
import { camelCase, startCase, upperCase, lowerCase, upperFirst, } from 'lodash-es';
// @see: https://medium.com/@robertsavian/javascript-case-converters-using-lodash-4f2f964091cc
export function pascalCase(str) {
    return startCase(camelCase(str)).replace(/ /g, '');
}
export function constantCase(str) {
    return upperCase(str).replace(/ /g, '_');
}
export function dotCase(str) {
    return lowerCase(str).replace(/ /g, '.');
}
export function pathCase(str) {
    return lowerCase(str).replace(/ /g, '/');
}
export function sentenceCase(str) {
    return upperFirst(lowerCase(str));
}
export function titleCase(str) {
    return startCase(camelCase(str));
}
//# sourceMappingURL=format.js.map